import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const HyundaiFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Hyundai"
      slug="/lenders/mis-sold-hyundai-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default HyundaiFinancePage
